import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/unregistered-students/UnregisteredStudentsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { UnregisteredStudentEditForm } from "./UnregisteredStudentEditForm";

export function UnregisteredStudentEdit({
  history,
  match: {
    params: { id }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, unregisteredStudent } = useSelector(
    (state) => ({
      actionsLoading: state.unregisteredStudents.actionsLoading,
      isSuccess: state.unregisteredStudents.isSuccess,
      type: state.unregisteredStudents.type,
      unregisteredStudent: state.unregisteredStudents.unregisteredStudent
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getUnregisteredStudent(id));
    return () => dispatch(actions.cleanUnregisteredStudentsState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Okul Dışı Öğrenci";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Belli Bir Okul Dışı Öğrenciyi Kaydeder
  const saveUnregisteredStudent = (values) => {
    dispatch(actions.saveUnregisteredStudent(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/okul-disi-ogrenciler"), 2500);
  };

  const btnRef = useRef();  
  const saveUnregisteredStudentClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">
          <UnregisteredStudentEditForm
            unregisteredStudent={unregisteredStudent}
            btnRef={btnRef}
            saveUnregisteredStudent={saveUnregisteredStudent}
          />
        </div>      
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveUnregisteredStudentClick}
          >
            Kaydet
          </button>
        </div>
      </CardFooter>
    </Card>
  );
}